import { styled } from "@mui/material/styles";
import { LinearProgress, linearProgressClasses } from "@mui/material";

export const BorderLinearProgress = styled(LinearProgress)(({ value }) => ({
  height: 14, // Grosor de la barra
  borderRadius: 7, // La mitad del height para que sea totalmente redondeada
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: value > 50 ? "#939393" : "#9aa3c3", // Organica
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 7,
    backgroundColor: value > 50 ? "#EF6C00" : "#002878", // Ads
  },
}));
